var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-alert", {
        attrs: {
          closable: false,
          "show-icon": "",
          title:
            "增值税电子普通发票的法律效力、基本用途、基本使用规定等与税务局监制的增值税普通发票相同",
          type: "warning",
        },
      }),
      _c(
        "avue-form",
        {
          ref: "avue_content",
          attrs: { option: _vm.optionInvoice },
          on: { submit: _vm.submitInvoice },
          model: {
            value: _vm.formInvoice,
            callback: function ($$v) {
              _vm.formInvoice = $$v
            },
            expression: "formInvoice",
          },
        },
        [
          _vm.supportSpecial
            ? _c(
                "el-select",
                {
                  attrs: {
                    slot: "invoiceType",
                    disabled: _vm.isSubmitted || _vm.isInvoiceDisabled,
                  },
                  on: { change: _vm.typeChanged },
                  slot: "invoiceType",
                  model: {
                    value: _vm.formInvoice.invoiceType,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInvoice, "invoiceType", $$v)
                    },
                    expression: "formInvoice.invoiceType",
                  },
                },
                _vm._l(_vm.typeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              )
            : _c(
                "el-select",
                {
                  attrs: {
                    slot: "invoiceType",
                    disabled: _vm.isSubmitted || _vm.isInvoiceDisabled,
                  },
                  on: { change: _vm.typeChanged },
                  slot: "invoiceType",
                  model: {
                    value: _vm.formInvoice.invoiceType,
                    callback: function ($$v) {
                      _vm.$set(_vm.formInvoice, "invoiceType", $$v)
                    },
                    expression: "formInvoice.invoiceType",
                  },
                },
                _vm._l(_vm.typeListNoSpecial, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
          _c("span", { attrs: { slot: "money" }, slot: "money" }, [
            _vm._v(_vm._s(_vm.formInvoice.money) + "元"),
          ]),
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.formInvoice.title)),
          ]),
          _c(
            "template",
            { slot: "menuForm" },
            [
              _vm.isSubmitted
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-edit" },
                      on: { click: _vm.modifyInvoice },
                    },
                    [_vm._v("修改")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }